module.exports = __webpack_public_path__ + "img/iraq-3.514519fa.png";